export const level: number = 6;
export const multiplier: number = 0.7;
